import {
  useInitiatePaystackCardTokenizationMutation,
  useVerifyCardTokenizationMutation,
} from "../redux/features/payment/payment.api";
import { useAppSelector } from "../redux/hooks";
import { payStackPopup } from "../utils/constants";

export const useCardTokenization = () => {
  const { profile } = useAppSelector((state) => state.auth);

  const [tokenizeCard, { isLoading: initiatingCardTokenization }] =
    useInitiatePaystackCardTokenizationMutation();

  const [verifyCardTokenization] = useVerifyCardTokenizationMutation();

  const doCardTokenization = async ({
    onSuccess = () => {},
  }: {
    onSuccess: () => void;
  }) => {
    const resp = await tokenizeCard({
      email: profile?.Email ?? "",
      amount: 50,
      type: "tokenization",
    });

    if (resp.data?.success) {
      payStackPopup.resumeTransaction(resp.data.data.data.access_code, {
        onSuccess: async (successData) => {
          const verifyResp = await verifyCardTokenization({
            trxref: successData.trxref,
            reference: successData.reference,
            mode: "paystack",
          });

          if (verifyResp?.data?.success) {
            onSuccess();
          }
        },
        onError: () => {},
        onCancel: () => {},
      });
    }
  };

  return {
    tokenizeCard,
    initiatingCardTokenization,
    doCardTokenization,
  };
};
